import React, { useState, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import {api_url} from '../../../config';
import { Switch } from 'antd';
import { InfinitySpin, ColorRing } from 'react-loader-spinner';
import { useSelector } from 'react-redux';
import axios from 'axios';
import api from '../../../utils/api';

const EditCustomer = ({toggle, data, fetchCustomers, categories}) => {
    const [name, setName] = useState(data?.name)
    const [city, setCity] = useState(data?.city)
    const [address, setAddress] = useState(data?.address)
    const [phone, setPhone] = useState(data?.phone)
    const [email, setEmail] = useState(data?.email)
    const [town, setTown] = useState(data?.town)
    const [ghana_post, setGhana_post] = useState(data?.ghana_post)
    const [user, setUser] = useState('')
    const [customer_status, setCustomer_status] = useState('')
    const [selectedStatus, setSelectedStatus] = useState('');
    const [status, setStatus] = useState(data?.status)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [category, setCategory] = useState(null)
    const [isCategoryOpen, setIsCategoryOpen] = useState(false)
    const [categorySearch, setCategorySearch] = useState('')
    const dropdownRef = useRef(null)
    const checker = data?.status === 'active'

    const {id, token, branch_id} = useSelector((state)=>state.auth)

    // Handle clicking outside category dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsCategoryOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Update category when data changes
    useEffect(() => {
        console.log('EditCustomer - Initial Data:', data);
        console.log('EditCustomer - Available Categories:', categories);
        
        if (data?.category) {
            console.log('EditCustomer - Current Category:', data.category);
            // Find the full category object from the categories list
            const fullCategory = categories?.find(cat => cat.id === data.category.id);
            console.log('EditCustomer - Found Category:', fullCategory);
            if (fullCategory) {
                setCategory(fullCategory);
            }
        } else if (data?.pivot?.category_id) {
            // If category is not directly in data but in pivot, find it
            const fullCategory = categories?.find(cat => cat.id === data.pivot.category_id);
            console.log('EditCustomer - Found Category from Pivot:', fullCategory);
            if (fullCategory) {
                setCategory(fullCategory);
            }
        }
    }, [data, categories]);

    // Filter categories based on search
    const filteredCategories = categories?.filter(cat =>
        cat?.name?.toLowerCase()?.includes(categorySearch?.toLowerCase())
    );
   
    const updateCustomer = async (e) => {
        e.preventDefault()
        console.log('EditCustomer - Update Request - Current Category:', category);
        console.log('EditCustomer - Update Request - Form Data:', {
            name,
            city,
            address,
            phone,
            email,
            town,
            ghana_post,
            status,
            category_id: category?.id
        });

        if (!category) {
            setError('Please select a category')
            return
        }
        const details = {
            name,
            city,
            address,
            phone,
            email,
            town,
            ghana_post,
            status,
            category_id: category.id
        }
        const required = !name || !city || !address || !phone || !email
        if (required) {
            setError('Please fill all required fields')
            return
        }
        if(!navigator.onLine){
            toast("You're offline")
            return
           }
        try {
            setLoading(true)
            console.log(`Making API request to: ${api_url}/api/v1/wholesaler/user/${id}/branch/${branch_id}/contact/${data.id}/inbranch`);
            const response = await api.put(
                api_url + `/api/v1/wholesaler/user/${id}/branch/${branch_id}/contact/${data.id}/inbranch`,
                details,
                {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
                }
            )
            console.log('EditCustomer - Update Response:', response.data);
            if (response.data) {
                toast.success('Customer updated successfully')
            fetchCustomers()
                toggle()
            }
        } catch (error) {
            console.error('EditCustomer - Update Error:', error.response?.data || error);
            setError(error?.response?.data?.error || 'Failed to update customer')
            setTimeout(() => {
                setError('')
            }, 6000)
        } finally {
            setLoading(false)
        }
    }
    
    const handleCustomerStatus = (checked) => {
        const status = checked ? 'active' : 'inactive';
        setStatus(status);
    }

    return (
        <div className='max-w-2xl overflow-auto sm:min-w-[300px] lg:min-w-[600px] mx-auto p-4'>
            <div className='mb-6 flex justify-between items-center'>
                <p className='font-lufga text-center font-semibold text-neutral-500'>Edit Customer</p>
                <div className='flex items-center gap-3'>
                    <label className="text-sm font-lufga">Status</label>
                    <Switch
                        defaultChecked={checker}
                        checkedChildren="active"
                        unCheckedChildren="inactive"
                        onChange={handleCustomerStatus}
                    />
                </div>
            </div>
            <form className="grid gap-4 mb-6 md:grid-cols-2">
                {loading && (
                    <div className="flex justify-center items-center w-full h-full bg-gradient-to-br from-opacity-40 to-opacity-60 backdrop-blur-sm absolute top-0 left-0">
                        <InfinitySpin color="#008DDA" loading={loading} size={36} />
                    </div>
                )}

                <div className='flex flex-col gap-3'>
                    <label className="text-sm font-lufga flex items-center gap-1" htmlFor="name">Name<span className='font-serif text-red-400'>*</span></label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        value={name}
                        onChange={(e) => { setName(e.target.value) }}
                        placeholder="Enter name"
                        className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
                        required
                    />
                </div>

                <div className='flex flex-col gap-3' ref={dropdownRef}>
                    <label className="text-sm font-lufga flex items-center gap-1">
                        Category<span className='font-serif text-red-400'>*</span>
                    </label>
                    <div className="relative">
                        <div
                            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 cursor-pointer"
                            onClick={() => setIsCategoryOpen(!isCategoryOpen)}
                        >
                            {category?.name || 'Select a category'}
                        </div>

                        {isCategoryOpen && (
                            <div className="absolute w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                                <input
                                    type="text"
                                    className="w-full p-2 border-b border-gray-300 focus:outline-none"
                                    placeholder="Search category"
                                    value={categorySearch}
                                    onChange={(e) => setCategorySearch(e.target.value)}
                                    onClick={(e) => e.stopPropagation()}
                                />

                                <div className="max-h-48 overflow-y-auto">
                                    {filteredCategories?.map((cat) => (
                                        <div
                                            key={cat.id}
                                            className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                                            onClick={() => {
                                                setCategory(cat);
                                                setIsCategoryOpen(false);
                                                setCategorySearch('');
                                            }}
                                        >
                                            {cat.name}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className='flex flex-col gap-3'>
                    <label className="text-sm font-lufga flex items-center gap-1">Email<span className='font-serif text-red-400'>*</span></label>
                    <input
                        type="text"
                        value={email}
                        onChange={(e) => { setEmail(e.target.value) }}
                        placeholder="Enter email"
                        className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
                        required
                    />
                </div>

                <div className='flex flex-col gap-3'>
                    <label className="text-sm font-lufga flex items-center gap-1" htmlFor="phone">Contact</label>
                    <input
                        type="text"
                        id="phone"
                        name="phone"
                        value={phone}
                        onChange={(e) => { setPhone(e.target.value) }}
                        placeholder="Enter contact"
                        className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
                        required
                    />
                </div>

                <div className='flex flex-col gap-3'>
                    <label className="text-sm font-lufga">City</label>
                    <input
                        type="text"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        placeholder="Enter city"
                        className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
                    />
                </div>

                <div className='flex flex-col gap-3'>
                            <label className="text-sm font-lufga">Town</label>
                            <input
                                type="text"
                                value={town}
                                onChange={(e) => setTown(e.target.value)}
                        placeholder="Enter town"
                                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
                            />
                        </div>

                        <div className='flex flex-col gap-3'>
                            <label className="text-sm font-lufga flex items-center gap-1" htmlFor="address">Address</label>
                            <input
                                type="text"
                                value={address}
                                onChange={(e) => { setAddress(e.target.value) }}
                        placeholder="Enter address"
                                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
                                required
                            />
                        </div>

                        <div className='flex flex-col gap-3'>
                    <label className="text-sm font-lufga flex items-center gap-1">Ghana Post</label>
                            <input
                                type="text"
                                value={ghana_post}
                                onChange={(e) => { setGhana_post(e.target.value) }}
                        placeholder="Enter Ghana Post"
                                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
                                required
                            />
                        </div>
            </form>
            <div className='flex justify-between items-center'>
                <div>
                    {customer_status ? (
                        <div>
                            <p className="bg-green-300 font-lufga rounded-md shadow-md px-2 py-1 text-xs text-center">{customer_status}</p>
                        </div>
                    ) : error ? (
                        <div>
                            <p className="bg-red-300 font-lufga rounded-md text-center shadow-md px-2 py-1 text-sm">
                            {typeof error === 'string' ? error : (
                                Object.keys(error).map((key) => (
                                    Array.isArray(error[key]) ? error[key][0] : error[key]
                                ))
                            )}
                        </p>
                        </div>
                    ) : null}
                </div>
                <button 
                    onClick={updateCustomer} 
                    disabled={loading}
                    className="bg-blue-500 font-lufga text-white py-2 px-4 rounded-md hover:bg-blue-600 shadow-md transition duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {loading ? 'Updating...' : 'Update'}
                </button>
            </div>
        </div>
    );
}

export default EditCustomer;
